export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=5a764384&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/lk/notifications/index.vue?vue&type=template&id=5a764384&
// module id = 1130
// module chunks = 0